/*
 * x-header-v2: 仅负责 Bicycles 三级下拉的内部交互
 * 外层(菜单开合/hover 展开/link 下拉/location/scroll)全部由 x-base.js 驱动
 */
document.addEventListener('DOMContentLoaded', () => {
  /* ---------- 电脑端: 左侧分类 tab 切换右侧内容 ---------- */
  document.querySelectorAll('.x-header-bikes__cat').forEach(($cat) => {
    $cat.addEventListener('click', (e) => {
      // 阻止冒泡到 li(避免触发 x-base.js 的 data-link 跳转)
      e.stopPropagation();
      // coming soon 分类不可点击, 不做切换
      if ($cat.classList.contains('x-header-bikes__cat--soon')) return;
      const idx = $cat.dataset.cat;
      const $bikes = $cat.closest('.x-header-bikes');
      $bikes.querySelectorAll('.x-header-bikes__cat').forEach(($c) => $c.classList.remove('x-header-bikes__cat--active'));
      $bikes.querySelectorAll('.x-header-bikes__panel').forEach(($p) => $p.classList.remove('x-header-bikes__panel--active'));
      $cat.classList.add('x-header-bikes__cat--active');
      const $panel = $bikes.querySelector(`.x-header-bikes__panel[data-panel='${idx}']`);
      if ($panel) $panel.classList.add('x-header-bikes__panel--active');
    });
  });

  /* ---------- 电脑端: 菜单间切换用瞬切(区分首开/切换/全关), 不改 x-base.js ----------
     - 首开(无菜单展开->展开): 保留 0.35s 完整揭示动画
     - 切换(已有菜单展开->另一个): 加 x-nav-switching, 内容瞬切 + 背景 0.15s(见 css)
     - 全关(离开 nav): 立即去 switching(收起恢复 0.35s), 300ms 后去 x-nav-open
     用自维护的 x-nav-open 标记判断, 不依赖 x-base 的 --active, 无时序问题 */
  const $navList = document.querySelector('.x-header__list');
  const $navBar = document.querySelector('.x-header__nav');
  if ($navList && $navBar) {
    let closeTimer = null;
    document.querySelectorAll('.x-header-nav__li').forEach(($li) => {
      // 只对带下拉(bikes/links)的项处理; 纯链接项无下拉
      if (!$li.querySelector('.x-header-bikes, .x-header-links')) return;
      $li.addEventListener('mouseenter', () => {
        if (xUtils.isMobile()) return;
        clearTimeout(closeTimer);
        if ($navList.classList.contains('x-nav-open')) {
          $navList.classList.add('x-nav-switching'); // 已有展开 -> 切换
        } else {
          $navList.classList.remove('x-nav-switching'); // 首开
        }
        $navList.classList.add('x-nav-open');
      });
    });
    $navBar.addEventListener('mouseleave', () => {
      if (xUtils.isMobile()) return;
      // 立即去 switching -> 收起恢复 0.35s 动画; 延迟去 open(与 x-base 300ms 收起同步)
      $navList.classList.remove('x-nav-switching');
      closeTimer = setTimeout(() => {
        $navList.classList.remove('x-nav-open');
      }, 300);
    });
  }

  /* ---------- 移动端: 一级手风琴(Bicycles/Framesets/Stores/About) 互斥展开 ---------- */
  const $mHeads = document.querySelectorAll('.x-hm__head');
  $mHeads.forEach(($head) => {
    $head.addEventListener('click', (e) => {
      e.stopPropagation();
      const $item = $head.closest('.x-hm__item');
      const isOpen = $item.classList.contains('x-hm__item--active');
      // 互斥: 关闭其他项
      document.querySelectorAll('.x-hm__item--active').forEach(($i) => {
        if ($i !== $item) $i.classList.remove('x-hm__item--active');
      });
      $item.classList.toggle('x-hm__item--active', !isOpen);
    });
  });
});
